import {  Card, Switch, Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { PreDealsTable } from '../PreDealsTable';
import { searchPreDeals } from '../../../../reducer/PreDeals/actions';

import './index.scss';
import ZorbaButton from '../../../../components/forms/ZorbaButton';

export const PreDealsList = () => {
  const dispatch = useDispatch();
  const [params, setParams] = useState({
    hasMatchingBuyers: false,
    didReceiveOffer: false,
  })
  const { total, currentPage, pageSize } = useSelector(
    ({ PreDealsReducer }) => PreDealsReducer,
  );

  useEffect(() => {
    dispatch(
      searchPreDeals({
        page: currentPage,
        pageSize,
      }),
    );
  }, [currentPage, pageSize]);

  const getLabel = (title, totalItems) => (
    <div className="label-container">
      {title}
      <div className="indicator-container">{totalItems}</div>
    </div>
  );
  const onChange = (key, val) => {
    setParams({ ...params, [key]: val })
  }
  const onSubmit = () => {
    dispatch(
      searchPreDeals({
        page: currentPage,
        pageSize,
        ...params,
      }),
    );
  }

  const tabs = [
    {
      key: 'tab1',
      label: getLabel('All', total),
      children: (
        <div>
          <div className="search-filters">
            
            <div className='form-item'>
              <label>Has matching buyers</label>
              <Switch
                checked={params.hasMatchingBuyers} onChange={newVal => onChange('hasMatchingBuyers', newVal)} >Pump</Switch>
            </div>
            <div className='form-item'>
              <label>Received offer</label>
              <Switch
                checked={params.didReceiveOffer} onChange={newVal => onChange('didReceiveOffer', newVal)} >Pump</Switch>
            </div>   

            <ZorbaButton style={{width: 200, marginBottom: 35}} onClick={onSubmit}>Search</ZorbaButton>
          </div>
          <div style={{paddingLeft: 20, color: '#333', fontSize: 16, fontWeight: 600}}>{`Deals: ${total}`}</div>
          <PreDealsTable />
        </div>
      ),
    },
  ];

  return (
    <div className="tabs-container pre-deals-list">
      <Tabs type="card" items={tabs} />
    </div>
  );
};
